$(document).ready(function() {
  var i = 0;
  var $elems = $('.textAnim-item');
  var length = $elems.length;

  setInterval(function () {
    $elems
    .removeClass('active')
    .eq(i++ % length)
    .addClass('active')
    .css('opacity', 0).animate({'opacity': 1});
  }, 3000);
});